import React, { Component, Fragment } from "react";
import Classnames from "classnames";
import { observer } from "mobx-react";
// import PropTypes from "prop-types";

import "./index.scss";
import { REGEXP, URS_CONFIG, URS_STYLE } from "@/utils/getting";
import Modal from "../modal";
import Store from "@/stores";

@observer
class Topbar extends Component {
	state = {
		nickname: "",
		tips: "",
		toggle: false
	}
	componentDidMount() {
		this.initUrs(() => {
			const { getUser } = this.props._authStore;
			const user = JSON.parse(localStorage.getItem("user"));
			user && user.overtime > new Date().getTime() && getUser();
		});
	}
	render() {
		const { logout, setNickame, toggleNickname, user } = Store._authStore;
		const { tips, toggle } = this.state;
		const isLogin = Classnames("link", { hide: !user, show: !!user });
		const isLogout = Classnames("link", { hide: !!user, show: !user });
		const loginBtn = (
			<Fragment>
				<div className={isLogout} id="register-btn">
					<a href="//zc.reg.163.com/regInitialized" title="免费注册">免费注册<em /></a>
					<div>
						<a href="//reg.vip.163.com/register.m" title="注册VIP邮箱(特权邮箱，付费)">注册VIP邮箱(特权邮箱，付费)</a>
					</div>
				</div>
				<div
					className={isLogout}
					id="login-btn"
					onMouseEnter={() => this.setState({ toggle: true })}
					onMouseLeave={() => this.setState({ toggle: false })}
				>
					<span>登录</span>
					<div className={toggle ? "show" : ""} id="urs-box"></div>
				</div>
			</Fragment>
		);
		const logoutBtn = (
			<Fragment>
				<div className={isLogin} onClick={logout}>注销</div>
				<div className={isLogin}>欢迎您，<span>{user && user.nickname}</span></div>
			</Fragment>
		);
		return (
			<div className="topbar-component">
				<div className="center clearfix">
					<a className="link" href="//ds.163.com" title="手机看游戏">网易大神</a>
					<a className="link" href="//www.163.com" title="网易首页">网易首页</a>
					{loginBtn}
					{logoutBtn}
				</div>
				<Modal toggle={toggleNickname} className="topbar-nickname-modal" close={() => setNickame("")}>
					<h3><i />欢迎来到凯恩之角，独一无二的你快来取一个独一无二的昵称吧！</h3>
					<input type="text" onChange={e => this.setState({ nickname: e.target.value })} />
					<label>{tips}</label>
					<div className="btn tac">
						<button id="logout-btn" onClick={() => setNickame("")}>退出登录</button>
						<button id="nickname-btn" onClick={this.setName.bind(this)}>确定</button>
					</div>
				</Modal>
			</div>
		);
	}
	initUrs(cb) {
		if (window.URS) {
			const opts = Object.assign({}, URS_CONFIG, {
				includeBox: "urs-box",
				initReady: () => cb && cb(),
				logincb: () => this.props._authStore.login(),
				style: URS_STYLE
			});
			new window.URS(opts);
		} else {
			alert("URS初始化脚本加载失败，请刷新页面重试");
		}
	}
	setName() {
		const { setNickame } = this.props._authStore;
		const { nickname } = this.state;
		if (!nickname) {
			return this.setState({ tips: "昵称不能为空" });
		} else if (!REGEXP.nickname.test(nickname)) {
			return this.setState({ tips: "长度3~7个汉字或3~15个英文" });
		} else if (!REGEXP.nicknameCn.test(nickname) && !REGEXP.nicknameEn.test(nickname)) {
			return this.setState({ tips: "只能输入全部汉字(长度3~7)或全部英文(长度3~15)" });
		} else {
			this.setState({ tips: "" });
		}
		setNickame(nickname);
	}
}
export default Topbar;